import { render } from "./CloseButton.vue?vue&type=template&id=7390b3e5&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=7390b3e5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7390b3e5"

export default script